import type { App } from 'vue';
import * as Sentry from '@sentry/vue';
import { router } from '@/plugins/1.router';

export default function (app: App) {
    if (import.meta.env.VITE_APP_ENV === 'local') {
        return;
    }

    Sentry.init({
        app,
        dsn: 'https://f15cea720d4591c604cb88233a915d1a@o4508992716668928.ingest.de.sentry.io/4509484452282448',
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({router, routeLabel: 'path'}),
        ],
        environment: import.meta.env.VITE_APP_ENV,
    });

}
